import './css/animated-input-label.css'

/**
 * Simple component to handle label animation in material UI style
 * 
 * @param {} Alpine 
 */
export default function (Alpine) {
    Alpine.directive('animated-input-label', (el, {}, { cleanup }) => {
        let canHandleChange = true

        const input = el.querySelector('input')
        if(!input){
            console.error('Animated input label component must contain an input tag !')
            return;
        }

        let handlerFocus = () => {
            canHandleChange = false
            el.classList.add('input-label-docked')
        }
        let handlerBlur = () => {
            if(!input.value.length) {
                el.classList.remove('input-label-docked')
            }
            canHandleChange = true
        }
        let handlerChange = () => {
            if(!canHandleChange) return

            if(!input.value.length) {
                el.classList.remove('input-label-docked')
            } else {
                el.classList.add('input-label-docked')
            }
        }
        let handlerLabelClick = () => {
            input.focus()
        }

        const init = () => {
            el.classList.add('animated-input-label')

            if(!el.querySelector('label')) {
                const label = document.createElement('LABEL')
                label.htmlFor = input.name
                label.innerHTML = input.placeholder
                input.placeholder = ''
                el.appendChild(label)

                label.addEventListener('click', handlerLabelClick)
                input.addEventListener('focus', handlerFocus)
                input.addEventListener('blur', handlerBlur)
                input.addEventListener('change', handlerChange)
            }

            handlerChange()

            el.classList.add('is-animated')
        }

        Livewire.hook('element.updated', (el, component) => {
            init && init()
        })

        init()
    
        cleanup(() => {
            label.removeEventListener('click', handlerLabelClick)
            input.removeEventListener('focus', handlerFocus)
            input.removeEventListener('blur', handlerBlur)
            input.removeEventListener('change', handlerChange)
        })
    
    })
}